import styled from "styled-components";

export const Banner3_Container = styled.div`
  width: 100vw;
  height: 80vh;
  background-color: #fff8f1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Banner3_Town = styled.div`
  margin-right: 17.8em;
  margin-top: 3em;
`;

export const Banner3_MainTitle = styled.div`
  width: 100%;
  height: 80%;
  margin-left: 22em;
  text-align: left;
  margin-top: 30em;
  color: #fe6f0f;
  font-family: GmarketSansBold;
`;

export const Banner3_Title = styled.div`
  font-family: GmarketSansMedium;
  font-size: 48px;
  color: #212529;
  margin-bottom: 0.5em;
  margin-top: 0.5em;
`;

export const Banner3_Introduce1 = styled.div`
  color: #7c7c7c;
  font-family: GmarketSansLight;
  font-size: 24px;
  margin-bottom: 1em;
`;
